<template>
  <div>
    <van-row class="payFoot">
      <!-- 免费领取 -->
      <van-col
        :span="24"
        class="text-c"
        v-show="GroupMsg.pinstatus == 4"
        @click="payment('buy')"
      >
        <van-button type="danger" class="xz-button-info freeCharge m-t-045"
          >免费领取</van-button
        >
      </van-col>

      <!-- 查看下载资料 -->
      <van-col
        :span="24"
        class="text-c"
        v-show="GroupMsg.pinstatus == 1"
        @click="payment()"
      >
        <van-button type="danger" class="xz-button-info freeCharge m-t-045"
          >查看/下载资料</van-button
        >
      </van-col>

      <!-- 单独购买/发起拼团 -->
      <van-col :span="24" class="text-c" v-show="GroupMsg.pinstatus == 2">
        <van-button
          class="xz-button-info signUp m-t-045 m-r-075"
          style="color: #fc7d15"
          @click="payment('buy')"
        >
          <p style="color: #fc7d15">¥{{ GroupMsg.originalprice }}</p>
          <p style="color: #fc7d15">单独报名</p>
        </van-button>
        <van-button
          type="danger"
          class="xz-button-info playGroup m-t-045"
          @click="payment('group')"
        >
          <p>¥{{ GroupMsg.pinprice }}</p>
          <p>
            {{
              $route.query.belongGroupId != undefined ? "参与拼团" : "发起拼团"
            }}
          </p>
        </van-button>
      </van-col>

      <!-- 倒计时邀请好友 -->
      <van-col
        :span="24"
        class="text-c"
        style="height: 3.5rem; line-height: 3.5rem"
        v-show="GroupMsg.pinstatus == 3"
      >
        <van-count-down :time="time" class="m-t-045">
          <template #default="timeData">
            <span>倒计时:</span>
            <span class="block">{{ Math.floor(timeData.hours / 24) }}</span>
            <span>天</span>
            <span class="block">{{ timeData.hours % 24 }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeData.minutes }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeData.seconds }}</span>
            <van-share-sheet
              v-model="showShare"
              title="邀请好友"
              :options="options"
              @select="share"
            />
            <input
              v-model="shareUrl"
              id="express_info_right"
              type="text"
              style="opacity: 0; position: absolute"
            />
            <van-button
              type="danger"
              class="xz-button-info playGroup m-l-045"
              @click="inviteFriends"
              >邀请好友</van-button
            >
          </template>
        </van-count-down>
      </van-col>
    </van-row>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop style="z-index: 99999999999999">
        <!-- <div class="block" /> -->
        <van-image :src="Invite" class="Invite f-l-r"></van-image>
      </div>
    </van-overlay>
  </div>
</template>

<script>
/* eslint-disable */

import { getWxConfig } from "@/model/pay/payServer";
import { getAppClient } from "@/utils/commonUtils";

export default {
  props: {
    GroupMsg: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      time: 1524856854215,
      showShare: false,
      options: [
        [
          { name: "微信", icon: "wechat" },
          //   { name: "朋友圈", icon: "wechat-moments" },
          //   { name: "微博", icon: "weibo" },
          //   { name: "QQ", icon: "qq" },
        ],
        [
          { name: "复制链接", icon: "link", className: "Url" },
          // { name: "分享海报", icon: "poster" },
          // { name: "二维码", icon: "qrcode" },
          // { name: "小程序码", icon: "weapp-qrcode" },
        ],
      ],
      freeInfo: {},
      show: false,
      Invite: require("@/assets/imgs/weChat/Invite.png"),
    };
  },
  created() {},
  methods: {
    // 发起支付
    payment(type) {
      if (localStorage.getItem("setToken") == null) {
        this.goLogin();
      } else {
        let item = this.GroupMsg;
        let query = this.$route.query;
        let payMsg = {
          id: item.id, // 活动id
          ctitle: item.title, // 课程名称
          coursePrice: item.originalprice, // 原价
          coupon: type == "buy" ? 0 : item.originalprice - item.pinprice, // 优惠金额
          discountPrice: type == "buy" ? item.originalprice : item.pinprice, // 实际支付金额
        };
        if (item.pinstatus == "4") {
          // 免费领取
          this.freeInfo = payMsg;
          this.freeData();
          this.$store.commit("Live/editGroupMsg", payMsg);
        } else if (item.pinstatus == "1") {
          // 查看下载资料
          this.$router.push({
            path: "/lookData",
            query: {
              pid: item.pid,
            },
          });
        } else {
          this.$store.commit("Live/editGroupMsg", payMsg);
          if (query.belongGroupId != undefined) {
            window.location.href = `${this.GLOBAL.payUrl}/pay?cid=${this.GroupMsg.pid}&type=${type}&ctitle=${payMsg.ctitle}&id=${payMsg.id}&coursePrice=${payMsg.coursePrice}&coupon=${payMsg.coupon}&discountPrice=${payMsg.discountPrice}&belongGroupId=${query.belongGroupId}`;
          } else {
            window.location.href = `${this.GLOBAL.payUrl}/pay?cid=${this.GroupMsg.pid}&type=${type}&ctitle=${payMsg.ctitle}&id=${payMsg.id}&coursePrice=${payMsg.coursePrice}&coupon=${payMsg.coupon}&discountPrice=${payMsg.discountPrice}`;
          }
        }
      }
    },
    freeData() {
      let query = this.freeInfo;
      let data = {
        pid: this.GroupMsg.pid,
        paymentway: 1,
        orderGroupId:
          query.belongGroupId == undefined ? null : query.belongGroupId,
      };
      this.Api({
        url: "api/addDatumOrder",
        method: "POST",
        data,
      }).then(() => {
        location.reload();
      });
    },
    // 邀请好友http://localhost:8080/pay?cid=1&type=group
    inviteFriends() {
      this.shareWx()
      this.showShare = true;
    },
    shareWx() {
      let data = {
        url: encodeURIComponent(location.href.split("#")[0]),
        appId: this.GLOBAL.wxPay.appid,
      };
      getWxConfig(data).then((res) => {
        let money = this.GroupMsg.originalprice;
        let title = "老铁，就差你啦~助我免费领BIM课程！";
        let desc = "我正在0元抢BIM课程，点链接参与活动，你也能领取一份哦！";
        if (money != 0) {
          title = "老铁，就差你啦~助我抢BIM课程！";
          desc = "我正在超低价抢BIM课程，点链接参与活动，你也能领取一份哦！";
        }
        let data = res.data;
        let _that = this;
        if (data && data.timeStamp) {
          window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: this.GLOBAL.wxPay.appid, // 必填，公众号的唯一标识
            timestamp: data.timeStamp, // 必填，生成签名的时间戳
            nonceStr: data.nonce_str, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: [
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "checkJsApi",
              "updateTimelineShareData",
              "updateAppMessageShareData",
              "hideMenuItems",
              "chooseImage",
              "uploadImage",
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
            if (wx.updateAppMessageShareData) {
              wx.updateAppMessageShareData({
                title, // 分享标题
                desc, // 分享描述
                link: _that.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
                  "http://webxiaozhu.oss-cn-beijing.aliyuncs.com/images/xiaozhup7tMHh", // 分享图标
                success: function (res) {
                  // alert("分享成功1");
                },
                cancel: function (res) {
                  alert("失败");
                  // 用户取消分享后执行的回调函数
                },
              });
            } else {
              wx.onMenuShareAppMessage({
                title, // 分享标题
                desc, // 分享描述
                link: _that.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
                  "http://webxiaozhu.oss-cn-beijing.aliyuncs.com/images/xiaozhup7tMHh", // 分享图标
                success: function (res) {
                  alert("分享成功2");
                },
                cancel: function (res) {
                  alert("失败");
                  // 用户取消分享后执行的回调函数
                },
              });
            }
            wx.updateTimelineShareData({
              title, // 分享标题
              desc, // 分享描述
              link: _that.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:
                "http://webxiaozhu.oss-cn-beijing.aliyuncs.com/images/xiaozhup7tMHh", // 分享图标
              success: function (res) {
                // alert("分享成功2");
              },
              cancel: function (res) {
                alert("失败");
                // 用户取消分享后执行的回调函数
              },
            });
            wx.error(function (res) {
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              alert("errorMSG:" + JSON.stringify(res));
            });
          });
        }
      });
    },
    // 分享到微信好友
    WxShare() {
      if (getAppClient() == "JSAPI") {
        this.showShare = false;
        this.show = true;
      } else {
        this.copyUrl();
        window.location.href = "weixin://";
      }
    },
    // 点击分享
    share(Option) {
      switch (Option.name) {
        case "微信":
          this.WxShare();
          break;
        case "复制链接":
          this.copyUrl();
          break;
      }
    },
    copyUrl() {
      let oInput = document.createElement("input");
      oInput.value = this.shareUrl;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$toast({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },
  },
  computed: {
    shareUrl() {
      let query = this.$route.query;
      let belongGroupId = this.GroupMsg.orderGroupId;
      let uid =
        JSON.parse(localStorage.getItem("userInfo")) == undefined
          ? null
          : JSON.parse(localStorage.getItem("userInfo")).uid;
      if (belongGroupId == null || query.belongGroupId != undefined) {
        return window.location.href + "&uid=" + uid;
      } else {
        return (
          window.location.href +
          "&belongGroupId=" +
          belongGroupId +
          "&uid=" +
          uid
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.Invite {
  width: 50%;
}
.payFoot {
  height: 3.5rem;
  background-color: white;
}
// 免费领取按钮
.freeCharge {
  width: 11.5rem;
  height: 2.6rem;
  border-radius: 1.3rem;
}
// 单独报名按钮
.signUp {
  width: 8.15rem;
  height: 2.6rem;
  border-radius: 1.3rem;
  background: linear-gradient(90deg, #ffffff 0%, #ffffff 100%);
}
// 发起拼团按钮
.playGroup {
  width: 8.15rem;
  height: 2.6rem;
  border-radius: 1.3rem;
}
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #ee0a24;
}
.block {
  display: inline-block;
  width: 22px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background-color: #ee0a24;
}
</style>
